(function () {
  var MOBILE_MQ = window.matchMedia("(max-width: 768px)");

  function initCarousel(root) {
    if (!root || root.dataset.trxInit === "true") return;

    var viewport = root.querySelector("[data-trx-viewport]");
    var track = root.querySelector("[data-trx-track]");
    var cards = track
      ? Array.prototype.slice.call(track.querySelectorAll(".trx-card"))
      : [];
    var prevBtns = root.querySelectorAll("[data-trx-prev]");
    var nextBtns = root.querySelectorAll("[data-trx-next]");
    var dotsWrap = root.querySelector("[data-trx-dots]");

    if (!viewport || !track || !cards.length || !prevBtns.length || !nextBtns.length || !dotsWrap) {
      return;
    }

    root.dataset.trxInit = "true";

    var index = 0;
    var pages = 1;
    var cardWidth = 0;
    var gap = 24;
    var scrollRaf = 0;

    function isMobileScroll() {
      return MOBILE_MQ.matches;
    }

    function cardsPerView() {
      return window.innerWidth <= 980 ? 1 : 2;
    }

    function refreshMetrics() {
      var style = window.getComputedStyle(track);
      gap = parseFloat(style.columnGap || style.gap || "24") || 24;
      cardWidth = cards[0].getBoundingClientRect().width;
      if (isMobileScroll()) {
        pages = cards.length;
      } else {
        pages = Math.max(1, cards.length - cardsPerView() + 1);
      }
      index = Math.min(index, pages - 1);
    }

    function renderDots() {
      dotsWrap.innerHTML = "";
      for (var i = 0; i < pages; i += 1) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "trx-dot" + (i === index ? " is-active" : "");
        dot.setAttribute("aria-label", "Aller au témoignage " + (i + 1));
        dot.addEventListener(
          "click",
          (function (pageIndex) {
            return function () {
              goTo(pageIndex);
            };
          })(i)
        );
        dotsWrap.appendChild(dot);
      }
    }

    function updateButtons() {
      Array.prototype.forEach.call(prevBtns, function (btn) {
        btn.disabled = index === 0;
      });
      Array.prototype.forEach.call(nextBtns, function (btn) {
        btn.disabled = index >= pages - 1;
      });
    }

    function updateDots() {
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    function updateDesktop() {
      var offset = index * (cardWidth + gap);
      track.style.transform = "translateX(-" + offset + "px)";
      updateButtons();
      updateDots();
    }

    function scrollTargetForCard(i) {
      var card = cards[i];
      if (!card) return 0;
      return card.offsetLeft - track.offsetLeft;
    }

    function readIndexFromScroll() {
      var scrollLeft = viewport.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i += 1) {
        var dist = Math.abs(scrollTargetForCard(i) - scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function scrollToCard(i, behavior) {
      var left = scrollTargetForCard(i);
      try {
        viewport.scrollTo({ left: left, behavior: behavior || "smooth" });
      } catch (e) {
        viewport.scrollLeft = left;
      }
    }

    function updateMobile(skipScroll) {
      track.style.transform = "";
      if (!skipScroll) scrollToCard(index, "auto");
      updateButtons();
      updateDots();
    }

    function goTo(nextIndex) {
      index = Math.max(0, Math.min(nextIndex, pages - 1));
      if (isMobileScroll()) {
        scrollToCard(index, "smooth");
        updateMobile(true);
      } else {
        updateDesktop();
      }
    }

    function onScroll() {
      if (!isMobileScroll()) return;
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        var next = readIndexFromScroll();
        if (next !== index) {
          index = next;
          updateButtons();
          updateDots();
        }
      });
    }

    Array.prototype.forEach.call(prevBtns, function (btn) {
      btn.addEventListener("click", function () {
        if (index > 0) goTo(index - 1);
      });
    });

    Array.prototype.forEach.call(nextBtns, function (btn) {
      btn.addEventListener("click", function () {
        if (index < pages - 1) goTo(index + 1);
      });
    });

    function applyMode() {
      root.classList.toggle("is-mobile-scroll", isMobileScroll());
      refreshMetrics();
      renderDots();
      if (isMobileScroll()) {
        updateMobile(false);
      } else {
        updateDesktop();
      }
    }

    viewport.addEventListener("scroll", onScroll, { passive: true });
    applyMode();
    window.addEventListener("resize", applyMode);
    if (MOBILE_MQ.addEventListener) {
      MOBILE_MQ.addEventListener("change", applyMode);
    } else if (MOBILE_MQ.addListener) {
      MOBILE_MQ.addListener(applyMode);
    }
  }

  function boot() {
    var roots = document.querySelectorAll("[data-stellar-trx-carousel]");
    Array.prototype.forEach.call(roots, initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
